<template>
  <div ref="HeightAdjusterTarget">
    <v-card elevation="0">
      <v-card-title
        class="d-flex pt-0 pb-0 pl-5 pr-5 flex-row justify-space-between blue lighten-5"
        v-if="!hideTitleBar"
      >
        {{title}}
        <v-checkbox
          v-model="autoRefresh"
          label="Auto Refresh"
          class="text--white"
          v-if="!hideAutoRefreshBox"
        >Auto Refresh</v-checkbox>
      </v-card-title>
      <v-card-text class="pa-0">
        <!-- TODO use colors based on status -->
        <!-- TODO itemsPerPageOptions with more than 5 elements are not displayed correctly -->
        <v-data-table
          :headers="headersComputed"
          :items="itemsComputed"
          :loading="loading"
          item-key="ID"
          :server-items-length="serverItemsLength"
          :height="heightToFill"
          :page.sync="page"
          :items-per-page="itemsPerPage || 25"
          :sort-by="sortBy || headers[headers.length - 1].value"
          :sort-desc="sortDesc"
          :options.sync="options"
          :footer-props="{itemsPerPageOptions : [10,25,50,100,1000]}"
          @click:row="$emit('click:row',$event)"
          fixed-header
          must-sort
          style="border:1px solid #EEEEEE"
        >
          <!-- IF ACTIONS ARE ENABLED -->
          <template #item.action="{ item }">
            <v-btn
              text
              @click="$emit('click:move', item,item.listOrder-1)"
              color="primary"
              :disabled="item.listOrder == 0"
              v-if="moveActions"
            >
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
            <v-btn
              text
              @click="$emit('click:move',item, item.listOrder+1)"
              color="primary"
              v-if="moveActions"
              :disabled="item.listOrder == items.length - 1"
            >
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
            <v-btn text @click="$emit('click:view', item)" v-if="viewAction" color="primary">
              <v-icon>remove_red_eye</v-icon>
            </v-btn>
            <v-btn text @click="$emit('click:edit',item)" v-if="editAction" color="primary">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn text @click="$emit('click:delete', item)" v-if="deleteAction" color="error">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn
              @click="$emit('click:btn', item)"
              v-if="btnAction && (!shouldShowBtn || shouldShowBtn(item))"
              color="primary"
              small
            >{{btnText}}</v-btn>
          </template>
          <template #top>
            <v-toolbar flat color="grey lighten-4" v-if="exportable" dense>
              <div class="flex-grow-1 mt-2 text-left">
                <v-btn
                  color="primary"
                  text
                  small
                  dark
                  class="mb-2"
                  @click="exportToExcel"
                  :disabled="itemsComputed.length == 0"
                >
                  <v-icon left>get_app</v-icon>export data
                </v-btn>
              </div>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import HeightAdjuster from "../mixins/HeightAdjuster";
import { URLSearchParams } from "url";

function addClassAndStyle(parent, query, className, style) {
  console.log(query);
  parent.querySelectorAll(query).forEach(el => {
    console.log(el);
    el.className = el.className + " " + className;
    el.style += ";" + style;
    console.log(el);
  });
}

export default {
  name: "ADataTable",
  mixins: [HeightAdjuster],
  props: [
    "itemsPerPage",
    "sortBy",
    "sortDesc",
    "headerClass",
    "headers",
    "api",
    "apiParams",
    "editAction",
    "deleteAction",
    "moveActions",
    "viewAction",
    "btnAction",
    "btnText",
    "shouldShowBtn",
    "actionsAtFirst",
    "exportable",
    "freezeFirstNColumns",
    "tableWidth",
    "title",
    "hideTitleBar",
    "hideAutoRefreshBox",
    "autoRefreshInitVal"
  ],
  data: function() {
    return {
      page: 1,
      items: [],
      loading: false,
      options: {},
      serverItemsLength: 0,
      autoRefresh: false,
      autoRefreshTimer: undefined,
      autoRefreshIntervalSecs: 10
    };
  },
  computed: {
    headersComputed: function() {
      if (!!this.headerClass || this.isActionColumnRequired) {
        let a = [];
        if (this.actionsAtFirst) {
          a.push(this.actionHeader);
        }
        this.headers.forEach(element => {
          if (this.headerClass) {
            element.class = this.headerClass;
          }
          a.push(element);
        });
        if (!this.actionsAtFirst) {
          a.push(this.actionHeader);
        }
        return a;
      } else {
        return this.headers;
      }
    },
    itemsComputed: function() {
      let items = [];
      this.items.forEach(item => {
        this.headers.forEach(header => {
          if (header.format) {
            item[header.value] = header.format.formatter(
              item[header.format.value]
            );
          }
        });
        items.push(item);
      });
      return items;
    },
    isActionColumnRequired: function() {
      return (
        !!this.editAction ||
        !!this.deleteAction ||
        !!this.moveActions ||
        !!this.viewAction ||
        !!this.btnAction
      );
    },
    actionHeader: function() {
      return {
        text: "Action",
        value: "action",
        sortable: false,
        width: this.actionColumnLength
      };
    },
    actionColumnLength: function() {
      let length = 0;
      length = length + (this.editAction ? 100 : 0);
      length = length + (this.deleteAction ? 100 : 0);
      length = length + (this.moveActions ? 100 : 0);
      length = length + (this.viewAction ? 100 : 0);
      length =
        length +
        (this.btnAction ? (this.btnText ? this.btnText.length * 10 : 100) : 0);
      return length;
    },
    cusOrderByNames: function() {
      let m = {};
      this.headers.forEach(element => {
        if (element.cusOrderByName) {
          m[element.value] = element.cusOrderByName;
        }
      });
      return m;
    }
  },
  mounted() {
    if (this.autoRefreshInitVal) {
      this.autoRefreshIntervalSecs = this.autoRefreshInitVal;
      this.autoRefresh = true;
    }
    // set table width
    if (this.tableWidth && this.tableWidth > 0) {
      this.$el.querySelector("table").style =
        this.$el.querySelector("table").style +
        ";width:" +
        this.tableWidth +
        "px";
    }
    // enable freeze columns
    // TODO dirty hack. find a bettter way to do this
    if (this.freezeFirstNColumns && this.freezeFirstNColumns > 0) {
      this.$el.className = this.$el.className + " freezeColumns1";
      if (this.freezeFirstNColumns > 1)
        this.$el.className = this.$el.className + " freezeColumns2";
    }
    this.heightToReduce = this.exportable ? 170 : 130;
  },
  beforeDestroy() {
    // clear auto refresh when exiting the page
    this.autoRefreshTimer = clearInterval(this.autoRefreshTimer);
  },
  methods: {
    load() {
      this.loading = true;
      this.api.get(this.params(), data => {
        this.loading = false;
        this.items = data.d.items;
        this.serverItemsLength = data.d.count;
      });
    },
    params() {
      var q = {};
      if (this.apiParams) {
        Object.assign(q, this.apiParams);
      }
      Object.assign(q, {
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        orderByColumn:
          this.cusOrderByNames[this.options.sortBy[0]] ||
          this.options.sortBy[0],
        orderByDir: this.options.sortDesc[0] ? "desc" : "asc"
      });
      return q;
    },
    exportToExcel() {
      let p = this.params();
      p.export = true;
      p.page = 1;
      p.pageSize = 0;
      this.api.export(p);
    },
    setAutoRefresh() {
      if (this.autoRefresh) {
        if (!this.autoRefreshTimer) {
          this.autoRefreshTimer = setInterval(
            this.load,
            this.autoRefreshIntervalSecs * 1000
          );
        }
      } else {
        clearInterval(this.autoRefreshTimer);
      }
    }
  },
  watch: {
    options: function() {
      this.load();
    },
    apiParams: function() {
      if (this.options.page == 1) {
        this.load();
      } else {
        // this change triggers the above watch on options
        this.page = 1;
      }
    },
    autoRefresh: function() {
      this.setAutoRefresh();
    },
    autoRefreshInitVal: function() {
      this.autoRefresh = this.autoRefreshInitVal ? true : false;
      this.autoRefreshIntervalSecs = this.autoRefreshInitVal;
    }
  }
};
</script>

<style>
.freezeColumns1 th:nth-child(1),
.freezeColumns1 td:nth-child(1) {
  background-color: whitesmoke;
  position: sticky;
  left: 0;
  width: 200px;
}

.freezeColumns2 th:nth-child(2),
.freezeColumns2 td:nth-child(2) {
  background-color: whitesmoke;
  position: sticky;
  left: 200px;
  width: 200px;
}

.freezeColumns1 th:nth-child(1),
.freezeColumns2 th:nth-child(2) {
  z-index: 4;
}

.freezeColumns1 td:nth-child(1),
.freezeColumns2 td:nth-child(2) {
  z-index: 3;
}

.v-data-table table tr th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  font-weight: 900;
}

.v-data-table table tr td {
  height: 35px;
  font-size: 13px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
</style>